import script from "./sf-back-in-context.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-back-in-context.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__